import axios from "axios";
import {getUid, isUnauthorizedUser} from "./utils/anonymousUid";

const COMPOSITIONS_PATH = "/customers/compositions";

const shouldAttachKey = (url) =>
    typeof url === "string"
    && url.includes(COMPOSITIONS_PATH)
    && !url.includes("/drafts")
    && isUnauthorizedUser();

axios.interceptors.request.use((config) => {
    if (!shouldAttachKey(config.url)) {
        return config;
    }

    const params = config.params || {};
    if (params.key != null && params.key !== "") {
        return config;
    }
    if (params.uuid != null && params.uuid !== "") {
        return config;
    }

    config.params = {
        ...params,
        key: getUid(),
    };

    return config;
});
